<div mat-dialog-content
	class="cm-ranch-create-step-content">
	<h3 class="cm-ranch-create-step-heading">
		{{ 'Weather Stations' | translate }}
	</h3>

	<p class="cm-ranch-create-step-help">
		Select the weather station nearest to your ranch. You can also add backup weather stations in case your primary station goes offline.
	</p>

	<button
		class="bk-button bk-create-button cm-ranch-create-add-button"
		(click)="openAddWeatherStationDialog()">
		<mat-icon class="cm-ranch-create-add-button__icon">add</mat-icon>
		{{'Add Weather Station' | translate }}
	</button>

	<table *ngIf="weatherStationControls.length > 0"
		class="bk-form__table cm-irrigation-methods-ui__table">
		<colgroup>
			<col span="1" class="cm-irrigation-methods-ui__col1">
			<col span="1" class="cm-irrigation-methods-ui__col2">
			<col span="1" class="cm-irrigation-methods-ui__col3">
			<col span="1" class="cm-irrigation-methods-ui__col4">
		</colgroup>
		<thead>
			<th>
				{{ 'Priority' | translate }}
			</th>
			<th>
				{{ 'Name' | translate }}
			</th>
			<th class="cm-tcell--align-right">
				{{ 'Distance' | translate }}
			</th>
			<th>
				{{ 'Action' | translate }}
			</th>
		</thead>
		<tbody>
			<tr *ngFor="let station of weatherStationControls; let i = index"
				class="cm-table-row--padded">
				<td>
					{{ station.get('Priority').value }}
				</td>
				<td>
					{{ station.get('Name').value }}
				</td>
				<td class="cm-tcell--align-right">
					<ng-container *ngIf="station.get('Distance').value !== null && station.get('Distance').value !== undefined">
						{{ station.get('Distance').value }} {{ 'miles' | translate }}
					</ng-container>
				</td>
				<td class="cm-irrigation-methods-ui__action">
					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						[disabled]="i === 0"
						(click)="moveWeatherStationUp(i, $event)">
						<mat-icon matTooltip="{{ 'Move Up' | translate }}">arrow_upward</mat-icon>
					</button>

					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						[disabled]="i === weatherStationControls.length - 1"
						(click)="moveWeatherStationDown(i, $event)">
						<mat-icon matTooltip="{{ 'Move Down' | translate }}">arrow_downward</mat-icon>
					</button>

					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						(click)="deleteWeatherStation(i, $event)">
						<mat-icon matTooltip="{{ 'Delete' | translate }}">delete</mat-icon>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<div mat-dialog-actions
	align="end">
	<button class="bk-button__delete"
		(click)="cancel()">
		{{ 'Cancel' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium bk-button--text-only bk-dialog__button--secondary"
		(click)="back()">
		{{ 'Back' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium"
		[disabled]="form && !form.valid"
		(click)="next()">
		{{ 'Next Step' | translate }}
	</button>
</div>
